import PropTypes from "prop-types";

function AlertasMobile({ app, config }) {
  return <></>;
}

AlertasMobile.defaultProps = {
  app: null,
  config: {},
};

AlertasMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default AlertasMobile;
